import { ReferenceFilterOperation } from "abweb/dto/generated/inputargs/ReferenceFilterOperation";
import { ReferenceFilterValueBase } from "abweb/dto/generated/inputargs/ReferenceFilterValueBase";
export class ReferenceFilterValue extends ReferenceFilterValueBase {
  static createReferenceFilterValue(displayValue, isCaseSensitive, isOpNegated, op, refID, stringValue) {
    const retVal = new ReferenceFilterValue();
    retVal.initReferenceFilterValue(null, displayValue, isCaseSensitive, isOpNegated, op, refID, stringValue);
    return retVal;
  }
  constructor() {
    super();
    this.initReferenceFilterValue(null, null, false, false, ReferenceFilterOperation.Object, null, null);
  }
  clone() {
    return ReferenceFilterValue.createReferenceFilterValue(this.displayValue, this.isCaseSensitive, this.isOpNegated, this.op, super.refID, super.stringValue);
  }
  get displayValue() {
    return super.displayValue;
  }
  set displayValue(value) {
    super.displayValue = value;
  }
  get isCaseSensitive() {
    return super.isCaseSensitive;
  }
  set isCaseSensitive(value) {
    super.isCaseSensitive = value;
  }
  get isOpNegated() {
    return super.isOpNegated;
  }
  set isOpNegated(value) {
    super.isOpNegated = value;
  }
  get op() {
    return super.op;
  }
  set op(value) {
    super.op = value;
  }
  get refID() {
    return super.refID;
  }
  set refID(value) {
    super.refID = value;
  }
  get stringValue() {
    return super.stringValue;
  }
  set stringValue(value) {
    super.stringValue = value;
  }
}
//# sourceMappingURL=ReferenceFilterValue.js.map
